export default __webpack_public_path__ + "static/media/bgContact.2bbfaed5.svg";